// src/pages/UTMHandlerHealth.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import MobileNumberForm from '../components/MobileNumberForm';
import CryptoJS from "crypto-js";

const UTMHandlerHealth = () => {

    useEffect(() => {
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-17300193684/16aICJnwx48bEJSDsLlA',
                transaction_id: '',
            });
        }
    }, []);

    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();

    const searchParams = new URLSearchParams(location.search);

    const utmSource = searchParams.get("utm_source") || "";
    const utmMedium = searchParams.get("utm_medium") || "";

    const [msisdn, setMsisdn] = useState(""); // State to hold the decrypted msisdn
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(""); // Error state
    const { serviceidtest } = useParams();
    const hasSubmitted = React.useRef(false);

    const backgroundImages = '/images/Zong/HealthIn.jpg'

    useEffect(() => {
        if (window.fbq) {
            window.fbq('trackCustom', 'HealthPageView');
        }
    }, []);

    useEffect(() => {
        if (id === '1') {
            const fireConversion = () => {
                window.gtag('event', 'conversion', {
                    send_to: 'AW-17300193684/4TDyCKvyyI0bEJSDsLlA',
                    event_callback: () => {
                        console.log("Conversion event sent.");
                    }
                });
            };

            const waitForGtag = () => {
                if (typeof window.gtag === 'function') {
                    fireConversion();
                } else {
                    console.warn("gtag not available after waiting.");
                }
            };

            waitForGtag();
        } else {
            console.log("Conversion not triggered. serviceid ≠ 1");
        }
    }, [id]);

    // Automatically set utm_campaign based on ID
    const utmCampaign =
        id === "1" ? "Health Insurance" :
            id === "2" ? "Mobile Insurance" :
                "General";

    useEffect(() => {

        if (hasSubmitted.current) return; // Prevent duplicate submission
        hasSubmitted.current = true;

        // Store in localStorage
        localStorage.setItem("utm_source", utmSource);
        localStorage.setItem("utm_medium", utmMedium);
        localStorage.setItem("utm_campaign", utmCampaign);
        localStorage.setItem("utm_route_id", id);

        // Prepare API request body
        const body = {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_term: "",
            utm_content: "",
            utm_compaign: utmCampaign, // Note: this is using "utm_compaign" to match backend spelling
        };

        // Call API
        fetch('https://digital.webdoc.com.pk/mta/public/api/v1/UTM/save-utm', {
            method: 'POST',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                console.log("UTM saved:", data);

                // Redirect based on ID
                navigate(`/${id}`, { replace: true });
            })
            .catch(error => {
                console.error("Error saving UTM data:", error);
                navigate("/", { replace: true });
            });

    }, [navigate, utmSource, utmMedium, utmCampaign, id]);

    const handleChange = (event) => {

        //setInput(cleanedInput);
        setMsisdn(event.target.value); // Update msisdn state
        setError(""); // Clear any existing errors
    };

    const decryptData = (encryptedData, key) => {
        const decryptedBase64 = CryptoJS.enc.Base64.parse(encryptedData);
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: decryptedBase64 },
            CryptoJS.enc.Utf8.parse(key),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.NoPadding,
            }
        );

        return decrypted.toString(CryptoJS.enc.Utf8).replace(/[\r\n\s]+/g, ''); // Remove all spaces

    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("http://115.42.72.186:8088/HE/test.php"); // API URL
                // const response = await fetch("http://192.168.100.250:8088/HE/Econ.php"); // API URL
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                const result = await response.json();
                console.log(result);

                // Assume result contains encrypted msisdn
                const encryptedMsisdn = result.msisdn;
                const key = "dacq@11223344556";

                // Decrypt msisdn
                const decryptedMsisdn = decryptData(encryptedMsisdn, key); // Spaces already removed
                const formattedMsisdn = decryptedMsisdn.startsWith("92")
                    ? "0" + decryptedMsisdn.substring(2) // Add "0" if it starts with "92"
                    : decryptedMsisdn;

                setMsisdn(formattedMsisdn.trim().replace(/[^\x20-\x7E]/g, ''));

                console.log(formattedMsisdn); // Output without spaces
                console.log(decryptedMsisdn); // Output without spaces
            } catch (error) {
                console.error("Error fetching or decrypting msisdn:", error);
                setError("Failed to fetch data. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (id === '1' || id === 1) {
            const pixelIds = {
                1: 'D3THJ1JC77U816ES7CEG',  // first TikTok Pixel ID
            };

            const pixelId = pixelIds[id];
            if (!pixelId) return;

            // Prevent duplicate loads
            if (window.ttq) {
                window.ttq.page();
                console.log(`TikTok Pixel ${pixelId} already initialized`);
                return;
            }

            // ✅ Define TikTok loader function
            const loadTikTokPixel = (w, d, t, pixelId) => {
                w.TiktokAnalyticsObject = t;
                const ttq = (w[t] = w[t] || []);
                ttq.methods = [
                    "page", "track", "identify", "instances", "debug", "on",
                    "off", "once", "ready", "alias", "group", "enableCookie",
                    "disableCookie", "holdConsent", "revokeConsent", "grantConsent"
                ];

                ttq.setAndDefer = function (t, e) {
                    t[e] = function () {
                        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                };

                for (let i = 0; i < ttq.methods.length; i++) {
                    ttq.setAndDefer(ttq, ttq.methods[i]);
                }

                ttq.instance = function (t) {
                    const e = ttq._i[t] || [];
                    for (let n = 0; n < ttq.methods.length; n++) {
                        ttq.setAndDefer(e, ttq.methods[n]);
                    }
                    return e;
                };

                ttq.load = function (e, n) {
                    const r = "https://analytics.tiktok.com/i18n/pixel/events.js";
                    ttq._i = ttq._i || {};
                    ttq._i[e] = [];
                    ttq._o = ttq._o || {};
                    ttq._o[e] = n || {};
                    const s = d.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = `${r}?sdkid=${e}&lib=${t}`;
                    const f = d.getElementsByTagName("script")[0];
                    f.parentNode.insertBefore(s, f);
                };

                ttq.load(pixelId);
                ttq.page();
            };

            // ✅ Call the function (this avoids the ESLint “unused expression” issue)
            loadTikTokPixel(window, document, 'ttq', pixelId);

            console.log(`✅ TikTok Pixel loaded: ${pixelId}`);
        }

    }, [id]);

    return (
        <div>
            <Header />
            <HeroSection imagelink={backgroundImages} />
            <MobileNumberForm Initialmsisdn={msisdn} serviceid="1" handleChange={handleChange} error={error} />
        </div>
    );
};

export default UTMHandlerHealth;
